// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export default css`
  &.bundle-productsList-container {
    margin-top: 16px;

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 24px;
    }
  }

  .outfiting-list-container {
    display: flex;
    flex-direction: column;

    @media ${(props) => props.theme.mediaQuery.medium} {
      row-gap: 16px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      row-gap: 32px;
    }
  }

  .horizontal-separator {
    width: 100%;
    height: 1px;
    background: #d8d8d8;
    margin: 16px 0;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 10px 0;
    }
  }

  .button-wrapper {
    position: relative !important;
    margin: unset !important;
  }
  .bundle-list-product-item {
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 342px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-height: 292px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      min-height: 691px;
    }
  }
`;

export const StyledPaginatedListSkeleton = styled.div`
  width: 100%;
  @media ${(props) => props.theme.mediaQuery.large} {
    row-gap: 32px;
    margin-top: 24px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    row-gap: 16px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    row-gap: 24px;
    margin-top: 16px;
  }

  .horizontal-separator {
    width: 100%;
    height: 1px;
    background: #d8d8d8;
    margin: 16px 0;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 10px 0;
    }
  }
  .list-skeleton-container {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 342px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 292px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 691px;
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 24px !important;
    }
    column-gap: 24px !important;
    height: 342px;
    width: 100%;
  }

  .image-skeleton {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 342px;
      width: 250px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 292px;
      width: 210px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 348px;
      width: 243px;
    }
  }
  .bundle-product-list-details-skeleton {
    @media ${(props) => props.theme.mediaQuery.large} {
      display: flex;
      column-gap: 24px !important;
      flex-grow: 1;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      row-gap: 24px !important;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
      row-gap: 12px !important;
    }
  }
  .bundle-product-list-title-skeleton {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 81px;
      width: 400px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 72px;
      width: 400px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 94px;
    }
  }
  .bundle-product-list-skeleton {
    display: flex;
    flex-direction: column;
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-grow: 1;
      justify-content: space-between;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      row-gap: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      row-gap: 16px !important;
    }
  }
`;
